import { Stack } from "@bookingcom/bui-react";
import React, { useEffect, useRef } from "react";
import FareCard from "../../../../components/elements/FlightCard/components/FareCard.js";
import { SkeletonFlightCard } from "../../../../components/elements/Skeleton/SkeletonFlightCard.js";
import { convertFlightToFare } from "../utils.js";
import { useI18n } from "@bookingcom/lingojs-react";
import useBrandedFares from "../../../hooks/useBrandedFares.js";
import Frame from "../../../../components/elements/Frame/index.js";
import useTrackFirstFarePriceMismatch from "../../../hooks/useTrackFirstFarePriceMismatch.js";
import { isDeltaAirlinesOffer } from "../../../../components/elements/FlightCard/utils.js";
import useIsInViewport from "../../../../hooks/useIsInViewport.js";
import flights_apex_web_delta_airlines_pilot_2026 from "../../../../utils/experiments/apex/flights_apex_web_delta_airlines_pilot_2026.js";
import useClientMetrics from "../../../../hooks/useClientMetrics.js";
import useTimer from "../../../../hooks/useTimer.js";
import { trackBrandedFareFeaturesOnBackendStages } from "../../../../utils/experiments/apex/flights_apex_web_filter_branded_fare_features_on_backend.js";
import { trackAlignedBrandedFareFeaturesStages } from "../../../../utils/experiments/apex/flights_apex_web_filter_align_branded_fare_features_apps.js";
import { findFareIndex } from "../../../utils/fares.js";
const FareSelector = ({ flight }) => {
    const i18n = useI18n();
    const { fetchStatus, brandedFareOffers } = useBrandedFares(flight.token);
    const hasBrandedFareOffers = !!brandedFareOffers && brandedFareOffers.length > 0;
    const containerRef = useRef(null);
    useTrackFirstFarePriceMismatch(flight, brandedFareOffers);
    const isInViewport = useIsInViewport(containerRef, [flight, brandedFareOffers], { threshold: 0.8 });
    const isDelta = isDeltaAirlinesOffer(flight);
    useEffect(() => {
        if (!hasBrandedFareOffers)
            return;
        trackBrandedFareFeaturesOnBackendStages("search_results", flight.segments);
        trackAlignedBrandedFareFeaturesStages("search_results", flight.segments);
    }, [flight.brandedFareInfo, flight.segments, hasBrandedFareOffers]);
    useEffect(() => {
        if (!isDelta)
            return;
        if (isInViewport && fetchStatus === "success" && !hasBrandedFareOffers) {
            flights_apex_web_delta_airlines_pilot_2026.goals.empty_delta_fares_seen();
        }
    }, [fetchStatus, isDelta, isInViewport, hasBrandedFareOffers]);
    const { trackClientMetric } = useClientMetrics();
    const loaderTimer = useTimer();
    useEffect(() => {
        if (fetchStatus === "loading" && isInViewport) {
            loaderTimer.start();
        }
        if (fetchStatus === "success") {
            const duration = loaderTimer.stop();
            if (duration)
                trackClientMetric("branded_fares_on_sr_loader_seen_ms", duration);
        }
    }, [fetchStatus, isInViewport, trackClientMetric, loaderTimer]);
    return (React.createElement("div", { ref: containerRef },
        React.createElement(Frame, { ml: 4, mr: 4, mb: 4 },
            React.createElement(Stack, { gap: 1 }, hasBrandedFareOffers ? (brandedFareOffers.map((brandedFareOffer) => {
                const globalIndex = findFareIndex(brandedFareOffer.token, brandedFareOffers);
                return (React.createElement(FareCard, { key: brandedFareOffer.token, index: globalIndex, fareOffer: brandedFareOffer, baseOffer: flight, fetchStatus: fetchStatus }));
            })) : (React.createElement(React.Fragment, null,
                React.createElement(FareCard, { fareOffer: convertFlightToFare(flight, i18n), baseOffer: flight, fetchStatus: fetchStatus }),
                fetchStatus === "loading" && React.createElement(SkeletonFlightCard, null)))))));
};
export default FareSelector;
